 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		12: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		12: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"60837ccb89dc8ebbcc6387be2973fd8324a24741","1":"fc7fd22e","2":"a2aded8a","3":"a97eea4eb58b54272a9e355bf1f27cae5a024cd1","4":"1fde3d47fb86094397d8c2f900152164ca189b8c","5":"4a754ec80b178711dc26cb30cefd4fcf6c941ecb","6":"25fe89d0b8edf22b03313ebee53ab58f54270c8f","7":"e8cbb670aba452384e47764d95ca5be58beb1144","8":"styles","9":"component---src-pages-merchant-pos-orders-summary-js","10":"component---src-pages-wallet-checkout-index-js","15":"component---src-pages-about-au-js","16":"component---src-pages-about-index-js","17":"component---src-pages-about-nz-js","18":"component---src-pages-checkout-js","19":"component---src-pages-embed-shopify-dashboard-js","20":"component---src-pages-error-js","21":"component---src-pages-index-js","22":"component---src-pages-info-js","23":"component---src-pages-merchant-index-js","24":"component---src-pages-merchant-login-callback-js","25":"component---src-pages-merchant-login-index-js","26":"component---src-pages-merchant-logout-js","27":"component---src-pages-merchant-orders-create-js","28":"component---src-pages-merchant-orders-dashboard-js","29":"component---src-pages-merchant-orders-review-js","30":"component---src-pages-merchant-orders-summary-js","31":"component---src-pages-merchant-pos-initiate-js","32":"component---src-pages-outcome-js","33":"component---src-pages-payment-complete-js","34":"component---src-pages-playground-checkout-js","35":"component---src-pages-playground-widget-js","36":"component---src-pages-playground-widget-testing-js","37":"component---src-pages-purchase-initiate-js","38":"component---src-pages-shopify-about-js","39":"component---src-pages-shopify-auth-js","40":"component---src-pages-shopify-install-js","41":"component---src-pages-shopify-payment-index-js","42":"component---src-pages-shopify-payment-outcome-js","43":"component---src-pages-shopify-payment-settings-js","44":"component---src-pages-wallet-index-js","45":"component---src-pages-wallet-login-callback-js","46":"component---src-pages-wallet-login-index-js"}[chunkId]||chunkId) + "-" + {"0":"fdbe74b2ef38cf17cd02","1":"1cfb5b95a821e8c868ec","2":"3e5171081a2fb23ac71c","3":"91f9477ab7411ea7e22a","4":"6a881bdca0bbbc8a91f4","5":"b285f9e94616d36e1a19","6":"9fdb34b89cef1437830b","7":"d5f457a64a6e8548ee6a","8":"cd63080e784be7b7e7cf","9":"4b9ed73b22890a1e7014","10":"3a0cf1bd2b0a9a33e5c5","15":"55af43b7bc8384aff7df","16":"3e8dd80b59cdbbf6dc84","17":"47fa56daaa213caeb6c3","18":"77fd4bd947a6f3d2bbfd","19":"0f41be7b71f0801a55b4","20":"309b0687098f21f34d79","21":"47142df4af9ab3ac16c2","22":"d239e31f9e380e8c3931","23":"f88b5150641cfa2f7e1a","24":"b8da1380da5dacc93754","25":"23c5280f334f09e38521","26":"4d623a88a25f011600f9","27":"a84d00aa080e101e15ae","28":"4e1dd17d688aebc0ffc2","29":"44da1fb028f6d43aa542","30":"828694550fb338bce4e1","31":"cf63ef72259492df0f7a","32":"92fb4fda5b1de8835ebf","33":"7aa9160b60bd52e2c7f2","34":"281082d62eecb105065a","35":"abf776a9ad9ec1c570d5","36":"5c5c0c627ef462ffe1d1","37":"f5b798153eec5c0c59e2","38":"4c9eb842c36084bdd2c0","39":"ba047867279c34745c9c","40":"df19243db7160dd10df9","41":"ed321190e297774d442d","42":"9458df8fda80a8c01092","43":"ea9eaea3009804fb27ac","44":"04622ad016efc69703f6","45":"07c64c53da620515ea35","46":"15c662b85966eb4cfe11"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"8":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"60837ccb89dc8ebbcc6387be2973fd8324a24741","1":"fc7fd22e","2":"a2aded8a","3":"a97eea4eb58b54272a9e355bf1f27cae5a024cd1","4":"1fde3d47fb86094397d8c2f900152164ca189b8c","5":"4a754ec80b178711dc26cb30cefd4fcf6c941ecb","6":"25fe89d0b8edf22b03313ebee53ab58f54270c8f","7":"e8cbb670aba452384e47764d95ca5be58beb1144","8":"styles","9":"component---src-pages-merchant-pos-orders-summary-js","10":"component---src-pages-wallet-checkout-index-js","15":"component---src-pages-about-au-js","16":"component---src-pages-about-index-js","17":"component---src-pages-about-nz-js","18":"component---src-pages-checkout-js","19":"component---src-pages-embed-shopify-dashboard-js","20":"component---src-pages-error-js","21":"component---src-pages-index-js","22":"component---src-pages-info-js","23":"component---src-pages-merchant-index-js","24":"component---src-pages-merchant-login-callback-js","25":"component---src-pages-merchant-login-index-js","26":"component---src-pages-merchant-logout-js","27":"component---src-pages-merchant-orders-create-js","28":"component---src-pages-merchant-orders-dashboard-js","29":"component---src-pages-merchant-orders-review-js","30":"component---src-pages-merchant-orders-summary-js","31":"component---src-pages-merchant-pos-initiate-js","32":"component---src-pages-outcome-js","33":"component---src-pages-payment-complete-js","34":"component---src-pages-playground-checkout-js","35":"component---src-pages-playground-widget-js","36":"component---src-pages-playground-widget-testing-js","37":"component---src-pages-purchase-initiate-js","38":"component---src-pages-shopify-about-js","39":"component---src-pages-shopify-auth-js","40":"component---src-pages-shopify-install-js","41":"component---src-pages-shopify-payment-index-js","42":"component---src-pages-shopify-payment-outcome-js","43":"component---src-pages-shopify-payment-settings-js","44":"component---src-pages-wallet-index-js","45":"component---src-pages-wallet-login-callback-js","46":"component---src-pages-wallet-login-index-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"f3ff09481557e2358abb","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
